<template>
  <a-flex vertical gap="small" class="wrapper-editor">
    <LabelTemplateEditObjectType :loading="loading" />

    <template v-if="selectedLabelTemplateObject">
      <LabelTemplateEditObjectMargins :loading="loading" />

      <a-form :model="formModel" layout="vertical" :disabled="loading">
        <a-form-item label="Ориентация" name="orientation">
          <a-select
            :options="labelTemplateFormStore.labelObjectOrientationOptions"
            v-model:value="labelTemplateFormStore.labelObjectOrientationField"
          ></a-select>
        </a-form-item>
      </a-form>
    </template>
  </a-flex>
</template>
<script setup lang="ts">
import LabelTemplateEditObjectType from "@/components/settings/labels/labelTemplateEdit/labelTemplateEditObject/labelTemplateEditObjectMain/LabelTemplateEditObjectType.vue";
import LabelTemplateEditObjectMargins from "@/components/settings/labels/labelTemplateEdit/labelTemplateEditObject/labelTemplateEditObjectMain/LabelTemplateEditObjectMargins.vue";
import { useLabelTemplateFormStore } from "@/stores/labelTemplate/labelTemplateFormStore";
import { computed } from "vue";
import { storeToRefs } from "pinia";

defineProps<{ loading: boolean }>();

const labelTemplateFormStore = useLabelTemplateFormStore();

const { labelObjectOrientationField, selectedLabelTemplateObject } =
  storeToRefs(labelTemplateFormStore);

const formModel = computed(() => ({
  orientation: labelObjectOrientationField.value,
}));
</script>

<style scoped lang="scss">
.wrapper-editor {
  width: 350px;
}
</style>
